export default __webpack_public_path__ + "static/media/calendar.7a646843.svg";